var GlobalDisplayHook = $({});

var DisplayRouter = (function (Backbone, _) {
	var Router = function (opts) {
		opts = opts || {};
		this._showEvent = opts.showEvent ? opts.showEvent : this._showEvent;
	};

	// NOTE: hack to make display router global to make work any other code related with display view changes
	Router.GlobalDisplayHook = {
		eventTypes: {
			changeDisplay: 'changeDisplay'
		}
	};
	_.extend(Router.GlobalDisplayHook, Backbone.Events);

	$.extend(Router.prototype, Backbone.Events, {
		display: function (type, data) {
			this._updateHistory(type, data);
			this.trigger(this._showEvent, type, data);
			Router.GlobalDisplayHook.trigger(Router.GlobalDisplayHook.eventTypes.changeDisplay, type, data);
			GlobalDisplayHook.trigger(Router.GlobalDisplayHook.eventTypes.changeDisplay, type, data);
		},

		listen: function (displayRoutes, cbMatch, cbNotMatch) {
			var isThisRoute = function (type) {
				return _.indexOf(displayRoutes, type) !== -1;
			};
			this.subscribe(function (type, data) {
				if (isThisRoute(type)) {
					cbMatch(data);
				} else {
					cbNotMatch(data);
				}
			});
		},

		subscribe: function (cb, context) {
			this.on(this._showEvent, cb, context);
		},

		getHistoryPrev: function () {
			return this._history[this._history.length - 2];
		},

		getHistoryCurrent: function () {
			return this._history[this._history.length - 1];
		},

		getHistoryDataPrev: function () {
			return this._historyData[this._history.length - 2];
		},

		getHistoryDataCurrent: function () {
			return this._historyData[this._history.length - 1];
		},

		getHistory: function () {
			return this._history;
		},

		removeLatest: function() {
			var index = this._history && this._history.length || 0;
            if (index > 0) {
                this._history = this._history.slice(0, index - 1);
				this._historyData = this._historyData.slice(0, index - 1);
            }
        },

		_updateHistory: function (type, data) {
			var i = _.indexOf(this._history, type);
			if (i !== -1) {
				this._history = this._history.slice(0, i + 1);
				this._historyData = this._historyData.slice(0, i + 1);
			} else {
				this._history.push(type);
				this._historyData.push({type: type, data: data});
			}
		},

		_showEvent: '_display',

		_history: [],

		_historyData: []
	});

	return Router;
})(Backbone, _);